<template>
  <div class="overflow-x-auto scrollbar-hidden member-datatable" data-test="member-datatable">
      <Datatable :api-params="paramsComputed" :api-url="'news/getNews'" :method-request="'POST'" :data-array-table="dataArrayTable" :key="key" :default-sort="[{field:'_id',dir:'desc'}]"/>
  </div>
</template>

<script>
import Datatable from "@/components/datatable/index.vue"
import { defineComponent,reactive,ref,onMounted, watch, computed } from "vue"
import Swal from "sweetalert2"
import axios from "axios"

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})

export default defineComponent({
    props:{
        filter:{
            type: Object
        },
        reloadTable:{
            type: Boolean,
            default: false
        }
    },
    components:{
        Datatable
    },
    setup(props,{emit}){
        const dataArray = ref()
        const params = ref({start: '1',draw: '1',length: '2'})
        const key = ref(1)
        watch(()=>props.filter, ()=>{
            key.value++
        })
        watch(()=>props.reloadTable,(val)=>{
            if(val){
                key.value++
            }
        })
        const paramsComputed = computed(() => ({...params.value, ...props.filter}))
        const dataArrayTable = reactive([
            {title:"หัวข้อข่าว", field:"TITLE", minWidth: 200, resizable:true, formatter:"textarea"},
            {title:"รายละเอียดโดยย่อ", field:"SHORT_DETAIL", hozAlign:"left",minWidth: 200, resizable:true, formatter:"textarea"},
            {title:"ประเภท", field:"CATEGORY", hozAlign:"left",minWidth: 200, resizable:true, formatter:"textarea"},
            {title:"การดำเนินการ", field:"action", hozAlign:"center", minWidth: 100,
                formatter:function(cell, formatterParams){
                    const editCallback = () => {
                        emit("updateNews",cell.getData())
                    };
                    const deleteCallback = () =>{
                        swalCustom.fire({
                            text:"ยืนยันลบข้อมูล",
                            icon:"warning",
                            showCancelButton: true,
                            reverseButtons: true,
                            confirmButtonText: 'ตกลง',
                            cancelButtonText: 'ยกเลิก',
                        }).then((result) => {
                        if (result.isConfirmed) {
                            var config = {
                                url: `${process.env.VUE_APP_BASE_API}news/${cell.getData()._id}`,
                                method: "PUT",
                                data: {
                                    update:{
                                        STATUS: "REMOVED",
                                    }
                                },
                            };
                            axios(config)
                            .then(() => {
                                swalCustom.fire({
                                    text: "สำเร็จ",
                                    icon: "success",
                                    timer: 3000, //timeOut for auto-close
                                    confirmButtonText: "ปิด",
                                }).then(() => {
                                    key.value++
                                });
                            })
                            .catch((error) => {
                                swalCustom.fire({
                                    text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                                    icon: "warning",
                                    timer: 3000, //timeOut for auto-close
                                    confirmButtonText: "ปิด",
                                });
                                console.log(error);
                            });
                        }
                        })
                    }
                    let divElm = document.createElement("div")
                    divElm.className = "flex lg:justify-center items-center"
                    let editBtn = document.createElement("span");
                    editBtn.className = "flex items-center hover:text-theme-1"
                    let icon = document.createElement("i");
                    icon.setAttribute("data-feather","edit")
                    icon.className = "w-4 h-4 mr-1"

                    editBtn.addEventListener("click", editCallback);
                    editBtn.append(icon);
                    editBtn.append("แก้ไข")
                    divElm.append(editBtn)
                    let delBtn = document.createElement("a")
                    let delIcon = document.createElement("i");
                    delIcon.setAttribute("data-feather","trash-2")
                    delIcon.className = "w-4 h-4 mr-1"
                    delBtn.className = "flex items-center text-theme-24 ml-2"
                    delBtn.append(delIcon)
                    delBtn.append("ลบ")
                    delBtn.addEventListener("click", deleteCallback);
                    divElm.append(delBtn)
                    const b = cash(divElm)
                    return b[0]
                }
            },
        ])

        return {
            dataArrayTable,
            params,
            key,
            paramsComputed,
            dataArray
        }
    }
})
</script>

<style lang="scss">
.member-datatable {

}
</style>